export const SET_BILLING = 'set_billing';
export const UPDATE_CARD = 'update_card';
export const UPDATE_PLAN = 'update_plan';
export const UPDATE_COUPON = 'update_coupon';
